import { useContext, useEffect, useRef, useState } from 'react';
import { InfoCircleFill, PersonAdd } from 'react-bootstrap-icons';
import { BiUserPlus } from 'react-icons/bi';
import Access from '../../../../libs/api/services/Access';
import Authentication from '../../../../libs/api/services/Authentication';
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider';
// import FlattenedHash from '../../../../libs/templating/FlattenedHash';

const animateCSSTransition = (element, animation, element2, animation2, prefix = 'animate__') =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;
    const animationName2 = `${prefix}${animation2}`;
    // const node = document.querySelector(element);
    if (!(element && element2)) {
      resolve('Animation ended');
      return
    }
    const node = element;
    const node2 = element2;
    node.classList.remove(`d-none`);
    node.classList.add(`${prefix}animated`, animationName);
    node.classList.add(`animate__faster`);
    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      node.classList.remove(`${prefix}animated`, animationName);
      node.classList.add(`d-none`);
      node2.classList.remove(`d-none`);
      node2.classList.add(`animate__faster`);
      node2.classList.add(`${prefix}animated`, animationName2);

      // node.classList.add(`d-none`);
      resolve('Animation ended');
    }


    node.addEventListener('animationend', handleAnimationEnd, { once: true });
  });
export default function DashboardWidgetConsent() {
  const { GlobalRef, helpRefs, showError, createModal } = useContext(CommonFunctionsContext)
  // const { results, setFilter, Queue } = useContext(DashboardContext)
  const [requests, setRequests] = useState()
  // const [loading, setLoading] = useState(true)
  const initilized = useRef(false)

  const load = async () => {
    initilized.current = false
    const req = await Access.ListPendingRequests().catch(() => { })
    if (req) {
      setRequests(req)
      initilized.current = true
    }
  }

  useEffect(() => {

    load()

  }, [])
  if (!initilized.current) return <></>
  if (initilized.current && (typeof requests === "undefined" || requests.length === 0)) return <></>
  // return <></>
  return (
    <div className={`col-lg-4 col-md-12 dashboard-card`} style={{ maxHeight: 'calc(50% - 0.5rem)', height: 'calc(50% - 0.5rem)' }}>
      <div className='text-center bg-secondary-container p-3 rounded h-100 d-flex flex-column'>
        <div className='flex-shrink-1'>
          <h3><InfoCircleFill className='me-2' />Access Requests</h3>
        </div>
        {
          <>
            <div style={{ overflowY: 'auto', overflowX: 'hidden' }} className='flex-grow-1 d-flex flex-column justify-content-start align-items-start '>
              {requests && requests.map(request =>
                <div
                  onClick={() => createModal(<ConsentModal request={request} onClosed={() => load()} />, "Consent", <BiUserPlus />)}
                  className='d-flex w-100 align-items-center justify-content-center ' key={request.id}>
                  <PersonAdd />
                  <div className='flex-grow-1'>
                    {request.shareWith.firstName} {request.shareWith.lastName}
                  </div>
                  {
                    {
                      "OVERRIDE": <button className='btn'>View</button>,
                      "REQUIRED": <button className='btn'>View</button>,
                      "NOTICE": <></>,
                    }[request.consentType]
                  }
                </div>
              )}
            </div>
          </>
        }

      </div>
    </div>
  )
}

export const ConsentModal = ({ close, request, onClosed }) => {
  const { showError } = useContext(CommonFunctionsContext)
  const handleApprove = () => {

    close(() => {
      Access.ApproveConsentRequest(request.rule.id, request.id).catch(showError)
        .then(() => onClosed())
    })
  }
  const handleDecline = () => {

    close(() => {
      Access.DeclineConsentRequest(request.rule.id, request.id).catch(showError)
        .then(() => onClosed())
    })
  }
  return <div className='d-flex flex-column flex-grow-1 p-3'>
    <div className='flex-grow-1'>
      <div className='text-center py-3'>
        {request.shareWith && `${request.shareWith.firstName} ${request.shareWith.lastName} would like the following access ${request.shareFor.id === parseInt(Authentication.UserId()) ? 'to your profile' : `for ${request.shareFor.firstName} ${request.shareFor.lastName}`} `}
      </div>
      <div className='shadow p-3 rounded flex-grow-1'>
        {request.rule.accessRuleResources.map(resource =>
          <div className='d-flex'>
            <div className='flex-grow-1' key={resource.id}>{resource.accessType} {resource.human}</div>
          </div>
        )}
      </div>
    </div>
    <div className='text-center'>
      <button onClick={handleDecline} className='btn bg-primary-container'>Decline</button>
      <button onClick={handleApprove} className='btn bg-primary-container'>Approve</button>
    </div>
  </div>
}